import { Grid } from '@material-ui/core'
import PropTypes from 'prop-types'
import { useState } from 'react'
import DialogForm from '../DialogForm'
import CommonTextField from '../TextFieldForm'

CategoryForm.propTypes = {
  open: PropTypes.bool,
  onValidate: PropTypes.func,
  onClose: PropTypes.func,
}

export default function CategoryForm({ open, onClose, onValidate, title }) {
  const initForm = {
    name: '',
    code: '',
  }
  const [form, setForm] = useState({
    name: '',
    code: '',
  })

  const [errors, setErrors] = useState({
    name: false,
    code: false,
  })

  function _handleChange(target) {
    setErrors({ ...errors, [target.name]: target.value === '' })

    setForm((prevForm) => ({
      ...prevForm,
      [target.name]: target.value,
    }))
  }

  function _handleValidate() {
    if (!errors.name && !errors.code && form.code && form.name) {
      onValidate(form)
      setForm({ initForm })
    }
  }
  return (
    <>
      <DialogForm open={open} onValidate={_handleValidate} onClose={onClose} title={title}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={9}>
            <CommonTextField
              name="name"
              required
              value={form.name}
              onChange={(e) => _handleChange(e.target)}
              label="Nom"
              error={errors.name}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <CommonTextField
              name="code"
              required
              value={form.code}
              onChange={(e) => _handleChange(e.target)}
              label="Code"
              error={errors.code}
            />
          </Grid>
        </Grid>
      </DialogForm>
    </>
  )
}
